<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="learning-path-page">
    <Header light />
    <div class="learning-path-banner">
      <img src="/images/LearningPath/全赛道.jpg" alt="全赛道学习路线" />
    </div>

    <main id="learning-path-top" class="learning-path-main">
      <header class="learning-path-heading">
        <!-- <span>LEARNING PATH</span> -->
        <h1>从能力构建到项目实战</h1>
        <p>四条课程路径覆盖应用开发、大模型、智能运维与视觉创意方向。</p>
      </header>

      <section
        v-for="(path, index) in learningPaths"
        :id="path.id"
        :key="path.id"
        class="learning-path-section"
      >
        <div class="learning-path-title">
          <span class="learning-path-number">{{ String(index + 1).padStart(2, "0") }}</span>
          <div class="learning-path-title-copy">
            <span class="learning-path-kicker">COURSE PATH / {{ String(index + 1).padStart(2, "0") }}</span>
            <h2>{{ path.title }}</h2>
            <p>{{ path.subtitle }}</p>
          </div>
        </div>
        <div class="learning-path-image-wrap" :style="{ aspectRatio: path.ratio }">
          <img :src="path.image" :alt="`${path.title}学习路线`" loading="lazy" />
        </div>
      </section>
    </main>
    <Footer />
  </div>
</template>

<script setup>
import Header from "../components/layout/Header.vue";
import Footer from "../components/layout/Footer.vue";
import "../assets/css/LearningPath.css";

const learningPaths = [
  {
    id: "intelligent-app",
    title: "智能应用开发",
    subtitle: "以企业架构为基础，完成AI能力接入、系统构建与智能体项目实战。",
    image: "/images/LearningPath/智能应用开发横图.jpg",
    ratio: "1920 / 1251",
  },
  {
    id: "large-model",
    title: "大模型开发",
    subtitle: "从Python与模型基础出发，进阶RAG、Agent、微调与多模态应用。",
    image: "/images/LearningPath/大模型开发横图.jpg",
    ratio: "1920 / 1251",
  },
  {
    id: "ai-ops",
    title: "AI运维",
    subtitle: "掌握Linux、数据库、云原生与智能运维，建立企业级交付能力。",
    image: "/images/LearningPath/运维横图.jpg",
    ratio: "1920 / 1251",
  },
  {
    id: "aigc-design",
    title: "AIGC视觉创意设计",
    subtitle: "融合设计基础、AI工具、电商视觉、新媒体设计与视频剪辑。",
    image: "/images/LearningPath/AIGC视觉设计规划.jpg",
    ratio: "1920 / 1354",
  },
];
</script>
